import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Spinner } from 'react-bootstrap';

import { history } from '../../../../../_helpers/history';
import { alertActions } from '../../../../../_actions/alert.actions';
import { doctorService } from '../../../../../_services/doctor.service';

import ViewProfile from './View';
import GetStarted from './GetStarted';

class ProfilePage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      licensedUser: null
    }
  }

  componentDidMount() {
    doctorService.getLandingById(this.props.user.licensedId)
      .then(response => {
          this.setState({ licensedUser: response })
      }).catch(() => {
        this.props.dispatch(alertActions.error('Could not load licensed user landing page at this time. Please try again later.'))
      })
      .then(() => {
        this.setState({ loading: false })
      })
  }

  render() {
    if (this.state.loading) {
      return <Spinner animation="border" role="status">
        <span className="sr-only">Loading...</span>
      </Spinner>
    }

    if (this.state.licensedUser.status === 'NOT_SETUP') {
      return <GetStarted startSetup={() => history.push('/landing/setup', { id: this.props.user.licensedId })    } />
    } else if (this.state.licensedUser.status === 'ACTIVE') {
      return <ViewProfile client={this.props.client} licensedUser={this.state.licensedUser} />
    }
  }
}

function mapStateToProps(state) {
  return {
    client: state.client
  };
}

export default connect(mapStateToProps)(ProfilePage);
